module.exports = __webpack_public_path__ + "img/LS.2868dd46.svg";